import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

// 预留：获取全部分类，供任务模块枚举使用
export async function getAllCategories(): Promise<Array<{ id: number | string; name?: string; displayName?: string }>> {
  const url = `${baseUrl}/activity/adminGetAllTaskCategories`;
  const { json } = await httpClient(url);
  // 兼容各种返回结构
  const rows = json?.data ?? json?.list ?? json?.items ?? json?.records ?? json ?? [];
  return Array.isArray(rows) ? rows : [];
}

// 将分类转换为 react-admin SelectInput 可用的 choices
export async function getCategoryChoices(): Promise<Array<{ id: number | string; name: string }>> {
  const categories = await getAllCategories();
  return categories.map((c: any) => ({ id: c.id, name: c.displayName || c.name || String(c.id) }));
}


